import * as React from 'react';
import { RightArrowHatIcon } from '../../common/Icons';
import { BillingAddress, Card } from 'fs-api-client';

interface BillingDetailsSummaryProperties {
    companyName?: string;
    card?: Card;
    onAdd: () => void;
    onEdit: () => void;
    billingAddress?: BillingAddress;
    billingName?: string;
}

export class BillingDetailsSummary extends React.Component<BillingDetailsSummaryProperties> {
    constructor(props: BillingDetailsSummaryProperties) {
        super(props);
    }

    public render(): JSX.Element {
        const companyName = this.getCompanyName();
        const creditCardSection = this.getCreditCardSection();
        return (
            <div onClick={this.props.onEdit} className="vertical__card center">
                <div className="box__label">
                    <div>Billing details</div>
                    <span className="link">
                        Edit
                        <RightArrowHatIcon width="5px" height="8px" />
                    </span>
                </div>
                <h3>
                    {companyName}
                </h3>
                {creditCardSection}
            </div>
        );
    }

    private getCompanyName(): string {
        const { billingName, companyName } = this.props;

        if (billingName) {
            return billingName;
        }

        if (companyName) {
            return companyName;
        }

        return 'Billing name';
    }

    private getCreditCardSection(): JSX.Element {
        return this.props.card ?
            (
                <div className="box__label bottom">
                    **** **** **** {this.props.card.numberLast4}
                    <span>{this.props.card.expiryMonth}/{this.props.card.expiryYear}</span>
                </div>
            ) :
            (
                <div className="btn btn-short" onClick={this.props.onAdd}> Add credit card</div>
            );
    }

}



// WEBPACK FOOTER //
// ./src/webportal/components/billing/details/BillingDetailsSummary.tsx